// Core
import React, { useState } from 'react';
import Slider from 'react-slick';
import { Box, Text, Button } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Components
import Card from 'components/Card/Card';
import { ReviewsIcon, LeftIcon, RightIcon } from 'components/Icons/Icons';

const NextArrow = ({ onClick }) => (
    <Button
        variant="button-lg"
        onClick={onClick}
        position="absolute"
        right={{base: '0px', md: '8px'}}
        top="0"
        w="64px"
        zIndex="1"
        borderRadius="full"
    >
      <RightIcon fontSize="24px" />   
    </Button>
);

const PrevArrow = ({ onClick }) => (
    <Button
        variant="button-lg"
        onClick={onClick}
        position="absolute"
        left={{base: '0px', md: '8px'}}
        top="0"
        w="64px"
        zIndex="1"
        borderRadius="full"
    >
        <LeftIcon fontSize="24px" />
    </Button>
);

const Prizes = ({ prizes, activeSlidePrize, setActiveSlidePrize }) => {
    const settings = {
        dots: true, 
        infinite: true,
        speed: 500,
        slidesToShow: 1, 
        slidesToScroll: 1,
        centerMode: true, 
        centerPadding: '0%',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: (current, next) => setActiveSlidePrize(next),
        appendDots: dots => (
          <Box mt="10px">
            <ul style={{ display: 'flex', justifyContent: 'center', gap: '4px' }}>
              {dots}
            </ul>
          </Box>
        ),
        customPaging: i => (
          <Box w="8px" h="8px" bg={i === activeSlidePrize ? '#2ABDFD' : '#8794C2'} borderRadius="full" />
        ),
    };

    return (
        <>
            { prizes.length > 1 ? (
                <Box
                  className="giveaways-prizes" 
                  position="relative"
                  zIndex="1"
                  mt={{base: '-8px', md: '32px'}}
                  py="28px"
                  overflow="hidden"
                  whiteSpace="nowrap">
                    <Slider {...settings}>
                        {prizes.map((card, index) => (
                            <Box key={card.id} transition="transform 0.3s ease" textAlign="center">
                            	<Text whiteSpace="normal" wordBreak="break-word" overflowWrap="break-word"
                                    zIndex="2" py="2px" px={{base: '20%', sm: '0'}} 
                                    variant="title-lg" fontSize="24px" fontStyle="normal">{card?.title}</Text>
                            </Box>
                        ))}
                    </Slider>
                </Box>
            ) : prizes.length === 1 ? (
                <Box pt="51px" transition="transform 0.3s ease" textAlign="center">
                    <Text zIndex="2" py="2px" variant="title-lg" fontSize="24px" fontStyle="normal">{prizes[0]?.title}</Text>
                </Box>
            ) : (<></>)}
        </>
    );
};

export default Prizes;